"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLegacyId = useLegacyId;
exports.useA11yId = useA11yId;
exports.useA11yIdBatch = useA11yIdBatch;
var react_1 = __importDefault(require("react"));
var react_id_generator_1 = require("react-id-generator");
function useLegacyId() {
    if (typeof react_1.default.useId === 'function') {
        return react_1.default.useId();
    }
    else {
        var _a = __read((0, react_id_generator_1.useId)(), 1), htmlId = _a[0];
        return htmlId;
    }
}
function idGenerator(base) {
    var suffix, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                suffix = '';
                _b.label = 1;
            case 1:
                _a = String;
                return [4, base + '-' + suffix];
            case 2:
                suffix = _a.apply(void 0, [_b.sent()]);
                _b.label = 3;
            case 3: return [3, 1];
            case 4: return [2];
        }
    });
}
function useA11yId(prefix) {
    var reactId = useLegacyId();
    var baseId = reactId + '-' + prefix;
    var iterator = idGenerator(baseId);
    iterator.next();
    return iterator;
}
function useA11yIdBatch(prefix, tags) {
    if (tags === void 0) { tags = []; }
    var iterator = useA11yId(prefix);
    iterator.next();
    return tags.map(function (tag) { return iterator.next(String(tag)).value; });
}
